const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Account {
    constructor(runtime) { this.runtime = runtime; this._user = null; }
    getInfo() {
        return {
            id: 'accountExt', name: '👤 アカウント', color1: '#4CAF50', color2: '#388E3C',
            blocks: [
                { opcode: 'isLoggedIn', blockType: BlockType.BOOLEAN, text: 'ログインしている？' },
                { opcode: 'getUsername', blockType: BlockType.REPORTER, text: 'ユーザー名' },
                { opcode: 'getUserId', blockType: BlockType.REPORTER, text: 'ユーザーID' },
                { opcode: 'login', blockType: BlockType.COMMAND, text: 'ログイン画面を表示' },
                { opcode: 'logout', blockType: BlockType.COMMAND, text: 'ログアウト' },
                '---',
                { opcode: 'saveProject', blockType: BlockType.COMMAND, text: 'プロジェクトを [N] として保存', arguments: { N: { type: ArgumentType.STRING, defaultValue: 'My Project' } } },
                { opcode: 'loadProject', blockType: BlockType.COMMAND, text: 'プロジェクト [ID] を読み込む', arguments: { ID: { type: ArgumentType.STRING, defaultValue: '' } } },
                { opcode: 'publishProject', blockType: BlockType.COMMAND, text: 'プロジェクトを公開' },
                { opcode: 'getMyProjects', blockType: BlockType.REPORTER, text: '自分のプロジェクト一覧' }
            ]
        };
    }
    isLoggedIn() { return this._user !== null; }
    getUsername() { return this._user ? this._user.name : ''; }
    getUserId() { return this._user ? this._user.id : ''; }
    login() { var name = prompt('ユーザー名を入力:'); if (name) { this._user = { id: 'user_' + Date.now(), name: name }; alert('ログインしました: ' + name); } }
    logout() { this._user = null; alert('ログアウトしました'); }
    saveProject(args) { var name = Cast.toString(args.N); alert('プロジェクト「' + name + '」を保存しました（デモ）'); }
    loadProject(args) { alert('プロジェクト読み込み機能（デモ）'); }
    publishProject() { alert('プロジェクトを公開しました（デモ）'); }
    getMyProjects() { return 'Project1,Project2,Project3'; }
}
module.exports = Scratch3Account;